import ProfileMenu from './ProfileMenu.container';

export default ProfileMenu;
